export const RO_DEFAULT_FILTERS = [
  {
    id: "seaWater",
    group: "chemistry",
    field: "type",
    label: "Sea Water",
    value: "SW",
  },
  {
    id: "brackishWater",
    group: "chemistry",
    field: "type",
    label: "Brackish Water",
    value: "BW",
  },
  {
    id: "nanofiltration",
    group: "chemistry",
    field: "type",
    label: "Nanofiltration",
    value: "NF",
  },
  {
    id: "diameter16in",
    group: "diameter",
    field: "size",
    label: "16 in",
    value: "16",
  },
  {
    id: "diameter8in",
    group: "diameter",
    field: "size",
    label: "8 in",
    value: "8",
  },
  {
    id: "diameter4in",
    group: "diameter",
    field: "size",
    label: "4 in",
    value: "4",
  },
  {
    id: "diameter2_5in",
    group: "diameter",
    field: "size",
    label: "2.5 in",
    value: "2.5",
  },
  {
    id: "others",
    group: "diameter",
    field: "size",
    label: "Others",
  },
  {
    id: "standardSpecialty",
    group: "specialty",
    field: "isStandard",
    label: "Standard",
  },
  {
    id: "sulfateRemoval",
    group: "specialty",
    field: "isSulfateRemoval",
    label: "Sulfate Removal",
  },
  {
    id: "lithium",
    group: "specialty",
    field: "isLi",
    label: "Lithium",
  },
  {
    id: "mld",
    group: "specialty",
    field: "isMld",
    label: "MLD",
  },
  {
    id: "brineRecovery",
    group: "specialty",
    field: "isSwbr",
    label: "Brine Recovery",
  },
  {
    id: "standardStatus",
    group: "status",
    field: "isStandard",
    label: "Standard",
  },
];
